import { useApiMaterialsV1MaterialProductsCreate } from 'api';
import { UseFormReturn } from 'form';
import { useNavigate } from 'react-router-dom';

import { CreateFormValues } from '../../pages/MaterialProductCreate/MaterialProductCreate';
import { MaterialProductFormInputValues } from '../../pages/schema';
import { handleError } from '../../utils/handleFormError/handleFormError';

export const useCreateMaterialProduct = (
  form: UseFormReturn<MaterialProductFormInputValues, unknown, CreateFormValues>
) => {
  const { setError } = form;
  const navigate = useNavigate();
  return useApiMaterialsV1MaterialProductsCreate({
    mutation: {
      onError(error) {
        handleError(error, setError);
      },
      async onSuccess(_) {
        navigate(`/ground-control/material-products/`);
      },
    },
  });
};
